import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './app';

let entryPoint: HTMLButtonElement;
let langSwitch: HTMLDivElement;

const initApp = (): void => {
  const mobileMenu = entryPoint.dataset.mmenu
    ? JSON.parse(entryPoint.dataset.mmenu)
    : null;
  const availableLanguages = langSwitch.dataset.mlangs
    ? JSON.parse(langSwitch.dataset.mlangs)
    : null;

  langSwitch.removeAttribute('data-mlangs');

  const root = createRoot(entryPoint);
  root.render(
    React.createElement(App, {
      mobileMenu,
      availableLanguages,
    }),
  );
};

const init = (): void => {
  entryPoint = document.querySelector('#denso-mobile-menu');
  langSwitch = document.querySelector('.lang-switch');

  if (entryPoint) {
    initApp();
  }
};

export default {
  init,
};
